export const moduleTypeOptions = [
  { value: "Accounts", label: "Accounts" },
  { value: "Candidates", label: "Candidates" },
  { value: "Jobs", label: "Jobs" },
  { value: "TOS", label: "TOS" },
  { value: "Custom", label: "Custom" },
];

export const accountSectionOptions = [
  { value: "Account_account", label: "Account Info" },
  { value: "Account_contact", label: "Account Contact" },
  { value: "Account_document", label: "Account Document" },
  { value: "Account_instruction", label: "Account Instruction" },
  { value: "Account_commercial", label: "Account Commercial" },
];

export const jobsSectionOptions = [{ value: "job_form", label: "Job Info" }];

export const candidateSectionOptions = [
  { value: "Candidate_basic_info", label: "Basic Info" },
  { value: "Candidate_work_experience", label: "Work Experiences" },
  { value: "Candidate_languages", label: "Languages" },
  { value: "Candidate_education_details", label: "Education Details" },
  { value: "Candidate_documents", label: "Documents" },
  { value: "Candidate_certification", label: "Certifications" },
  { value: "Candidate_employer_details", label: "Employer Details" },
];

export const customSectionOptions = [{ value: "all", label: "All" }];

export const tosSectionOptions = [{ value: "prepare_tos", label: "All" }];

export const elementLists = [
  {
    draggableLabelIcon: "mdi mdi-text-recognition",
    draggableLabel: "Text Input",
    draggablePrefix: "element",
    draggableId: "text",
    type: "field",
  },
  {
    draggableLabelIcon: "mdi mdi-numeric",
    draggableLabel: "Number Input",
    draggablePrefix: "element",
    draggableId: "number",
    type: "field",
  },
  {
    draggableLabelIcon: "mdi mdi-lock-outline",
    draggableLabel: "Password Input",
    draggablePrefix: "element",
    draggableId: "password",
    type: "field",
  },
  {
    draggableLabelIcon: "mdi mdi-email-outline",
    draggableLabel: "Email Input",
    draggablePrefix: "element",
    draggableId: "email",
    type: "field",
  },
  {
    draggableLabelIcon: "mdi mdi-file-outline",
    draggableLabel: "File Input",
    draggablePrefix: "element",
    draggableId: "file",
    type: "field",
  },
  {
    draggableLabelIcon: "mdi mdi-form-textbox",
    draggableLabel: "Text Area",
    draggablePrefix: "element",
    draggableId: "textarea",
    type: "field",
  },
  {
    draggableLabelIcon: "mdi mdi-form-select",
    draggableLabel: "Select",
    draggablePrefix: "element",
    draggableId: "select",
    type: "field",
  },
  {
    draggableLabelIcon: "mdi mdi-card-search-outline",
    draggableLabel: "Multi Input",
    draggablePrefix: "element",
    draggableId: "multiinput",
    type: "field",
  },
  {
    draggableLabelIcon: "mdi mdi-radiobox-marked",
    draggableLabel: "Radio",
    draggablePrefix: "element",
    draggableId: "radio",
    type: "field",
  },
  {
    draggableLabelIcon: "mdi mdi-checkbox-marked-outline",
    draggableLabel: "Checkbox",
    draggablePrefix: "element",
    draggableId: "checkbox",
    type: "field",
  },
  {
    draggableLabelIcon: "mdi mdi-calendar-month-outline",
    draggableLabel: "Date",
    draggablePrefix: "element",
    draggableId: "date",
    type: "field",
  },
  {
    draggableLabelIcon: "mdi mdi-calendar-month-outline",
    draggableLabel: "Date Month",
    draggablePrefix: "element",
    draggableId: "datemonth",
    type: "field",
  },
  {
    draggableLabelIcon: "mdi mdi-table",
    draggableLabel: "Table",
    draggablePrefix: "element",
    draggableId: "table",
    type: "field",
  },
  {
    draggableLabelIcon: "mdi mdi-text-shadow",
    draggableLabel: "Editor",
    draggablePrefix: "element",
    draggableId: "editor",
    type: "field",
  },
  {
    draggableLabelIcon: "mdi mdi-text-shadow",
    draggableLabel: "Editor 2",
    draggablePrefix: "element",
    draggableId: "editor2",
    type: "field",
  },
  {
    draggableLabelIcon: "mdi mdi-format-size",
    draggableLabel: "Text",
    draggablePrefix: "element",
    draggableId: "word",
    type: "field",
  },
  {
    draggableLabelIcon: "mdi mdi-shape-circle-plus",
    draggableLabel: "Button",
    draggablePrefix: "element",
    draggableId: "button",
    type: "field",
  },
  {
    draggableLabelIcon: "mdi mdi-refresh-circle",
    draggableLabel: "Button-Update",
    draggablePrefix: "element",
    draggableId: "buttonupdate",
    type: "field",
  },
  {
    draggableLabelIcon: "mdi mdi-cloud-upload-outline",
    draggableLabel: "Drag & Drop Files",
    draggablePrefix: "element",
    draggableId: "dragdropfiles",
    type: "field",
  },
  {
    draggableLabelIcon: "mdi mdi-star-four-points",
    draggableLabel: "LLM Question & Answers",
    draggablePrefix: "element",
    draggableId: "llmqa",
    type: "field",
  },
];

// Original Custom Element List
export const customElementLists = [
  {
    draggableLabelIcon: "ri-building-2-line",
    draggableLabel: "Industry Select",
    draggablePrefix: "element",
    draggableId: "selectindustry",
    type: "field",
  },
  {
    draggableLabelIcon: "ri-building-2-fill",
    draggableLabel: "Sub Industry Select",
    draggablePrefix: "element",
    draggableId: "selectsubindustry",
    type: "field",
  },
  {
    draggableLabelIcon: "ri-bank-line",
    draggableLabel: "Department Select",
    draggablePrefix: "element",
    draggableId: "selectdepartment",
    type: "field",
  },
  {
    draggableLabelIcon: "ri-account-box-fill",
    draggableLabel: "Account Owner Select",
    draggablePrefix: "element",
    draggableId: "selectaccountowner",
    type: "field",
  },
  {
    draggableLabelIcon: "ri-account-box-fill",
    draggableLabel: "Candidate Owner Select",
    draggablePrefix: "element",
    draggableId: "selectcandidateowner",
    type: "field",
  },
  {
    draggableLabelIcon: "mdi mdi-earth",
    draggableLabel: "Country Select",
    draggablePrefix: "element",
    draggableId: "selectcountry",
    type: "field",
  },
  {
    draggableLabelIcon: "ri-road-map-line",
    draggableLabel: "State Select",
    draggablePrefix: "element",
    draggableId: "selectstate",
    type: "field",
  },
  {
    draggableLabelIcon: "ri-road-map-fill",
    draggableLabel: "City Select",
    draggablePrefix: "element",
    draggableId: "selectcity",
    type: "field",
  },
  {
    draggableLabelIcon: "mdi mdi-currency-usd",
    draggableLabel: "Currency With Amount",
    draggablePrefix: "element",
    draggableId: "selectcurrency",
    type: "field",
  },
  {
    draggableLabelIcon: "mdi mdi-phone-outline",
    draggableLabel: "Landline Select",
    draggablePrefix: "element",
    draggableId: "selectlandline",
    type: "field",
  },
  {
    draggableLabelIcon: "mdi mdi-office-building",
    draggableLabel: "Parent Company",
    draggablePrefix: "element",
    draggableId: "parentcompany",
    type: "field",
  },
  {
    draggableLabelIcon: "mdi mdi-select",
    draggableLabel: "Single Select",
    draggablePrefix: "element",
    draggableId: "singleselect",
    type: "field",
  },
  {
    draggableLabelIcon: "mdi mdi-select",
    draggableLabel: "Single Select API",
    draggablePrefix: "element",
    draggableId: "singleselectapi",
    type: "field",
  },
  {
    draggableLabelIcon: "mdi mdi-select-multiple",
    draggableLabel: "Multi Select",
    draggablePrefix: "element",
    draggableId: "multiselect",
    type: "field",
  },
  {
    draggableLabelIcon: "mdi mdi-select-multiple",
    draggableLabel: "Multi Select API",
    draggablePrefix: "element",
    draggableId: "multiselectapi",
    type: "field",
  },
  {
    draggableLabelIcon: "mdi mdi-card-search-outline",
    draggableLabel: "Search Select",
    draggablePrefix: "element",
    draggableId: "searchselect",
    type: "field",
  },
  {
    draggableLabelIcon: "mdi mdi-file-document-multiple-outline",
    draggableLabel: "Multi File Input",
    draggablePrefix: "element",
    draggableId: "multifile",
    type: "field",
  },
  {
    draggableLabelIcon: "ri-account-box-fill",
    draggableLabel: "Account Name Select",
    draggablePrefix: "element",
    draggableId: "selectaccountname",
    type: "field",
  },
  {
    draggableLabelIcon: "ri-account-box-fill",
    draggableLabel: "Account Name All Select",
    draggablePrefix: "element",
    draggableId: "selectaccountnameall",
    type: "field",
  },
  {
    draggableLabelIcon: "ri-contacts-fill",
    draggableLabel: "Account Contact Select",
    draggablePrefix: "element",
    draggableId: "selectaccountcontact",
    type: "field",
  },
  {
    draggableLabelIcon: "ri-file-text-line",
    draggableLabel: "Form Template Select",
    draggablePrefix: "element",
    draggableId: "selectformtemplate",
    type: "field",
  },
  {
    draggableLabelIcon: "ri-file-text-line",
    draggableLabel: "Profile Feedback Status Select",
    draggablePrefix: "element",
    draggableId: "selectprofilefeedbackstatus",
    type: "field",
  },
  {
    draggableLabelIcon: "ri-account-box-fill",
    draggableLabel: "Account Owner",
    draggablePrefix: "element",
    draggableId: "accountowner",
    type: "field",
  },
  {
    draggableLabelIcon: "ri-account-box-fill",
    draggableLabel: "Account Type",
    draggablePrefix: "element",
    draggableId: "accounttype",
    type: "field",
  },
  {
    draggableLabelIcon: "mdi mdi-currency-usd",
    draggableLabel: "Pay Rate",
    draggablePrefix: "element",
    draggableId: "payrate",
    type: "field",
  },
  {
    draggableLabelIcon: "mdi mdi-currency-usd",
    draggableLabel: "Currency List",
    draggablePrefix: "element",
    draggableId: "currencyList",
    type: "field",
  },
  {
    draggableLabelIcon: "mdi mdi-gift",
    draggableLabel: "Benefits",
    draggablePrefix: "element",
    draggableId: "benefits",
    type: "field",
  },
];

export const layoutLists = [
  {
    draggableLabelIcon: "mdi mdi-rectangle-outline",
    draggableLabel: "Section",
    draggablePrefix: "layout",
    draggableId: "section",
    type: "row",
  },
  {
    draggableLabelIcon: "mdi mdi-format-align-justify",
    draggableLabel: "1 Column",
    draggablePrefix: "layout",
    draggableId: "1",
    type: "row",
  },
  {
    draggableLabelIcon: "mdi mdi-format-columns",
    draggableLabel: "2 Columns",
    draggablePrefix: "layout",
    draggableId: "2",
    type: "row",
  },
  {
    draggableLabelIcon: "mdi mdi-view-week-outline",
    draggableLabel: "3 Columns",
    draggablePrefix: "layout",
    draggableId: "3",
    type: "row",
  },
  {
    draggableLabelIcon: "mdi mdi-rectangle-outline",
    draggableLabel: "Column",
    draggablePrefix: "layout",
    draggableId: "Column",
    type: "col",
  },
];
